import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@progress/kendo-react-dialogs';
import I18n, { translate } from '@utils/i18n';
import api from '@utils/axios';
import { markAsPublishedProposalsPath } from 'routes';
import toast from 'react-hot-toast';

const namespace = 'features.proposals.index.publish_to_customer_portal';

function PublishToCustomerPortal({ proposalIds, proposalsCount, disabled, queryParams }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const toggleDialog = () => {
    setVisible(!visible);
  };

  const onSubmit = useCallback(() => {
    const body = new FormData();
    if (proposalIds) {
      body.append('ids', proposalIds);
    } else {
      body.append('all', 'true');
      // Server aborts if it resolves a different number of proposals than the user selected
      body.append('expected_count', proposalsCount);
    }

    setLoading(true);
    api
      .post(markAsPublishedProposalsPath({ format: 'json' }), body, { params: queryParams })
      .then(({ data }) => toast.success(data.message))
      .catch(({ response }) =>
        toast.error(
          response?.data?.errors ?? response?.data?.message ?? I18n.t('generic.error_occurred_contact_support')
        )
      )
      .finally(() => {
        setLoading(false);
        setVisible(false);
      });
  }, [proposalIds, proposalsCount, queryParams]);

  return (
    <>
      <button type="button" tabIndex="0" className="qmb-control" disabled={disabled} onClick={toggleDialog}>
        <i className="fa-light fa-arrow-right-to-bracket" />
        {translate('button', { namespace })}
      </button>
      {visible && (
        <Dialog title={I18n.t('generic.confirm')} className="qmb-dialog" onClose={toggleDialog} closeIcon={!loading}>
          {translate('confirm', { namespace, count: proposalsCount })}

          <div className="modal__footer pull-right" style={{ justifyContent: 'space-between' }}>
            <div className="mt-3">
              <button type="button" className="qmb-button" onClick={toggleDialog} disabled={loading}>
                {I18n.t('generic.cancel')}
              </button>
              <button type="button" className="qmb-button--submit" onClick={onSubmit} disabled={loading}>
                {I18n.t('generic.ok')}
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
}

PublishToCustomerPortal.propTypes = {
  proposalIds: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool.isRequired,
  proposalsCount: PropTypes.number.isRequired,
  queryParams: PropTypes.object.isRequired
};

PublishToCustomerPortal.defaultProps = {
  proposalIds: null
};

export default PublishToCustomerPortal;
